/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A sequencer device
 */
export type SequencerDevice = {
  /**
   * The alias of the sequencer device
   */
  alias: string;
  /**
   * The display name of the sequencer device
   */
  displayName: string;
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * The kind of the sequencer device
   */
  kind: string;
};

/** @internal */
export const SequencerDevice$inboundSchema: z.ZodType<
  SequencerDevice,
  z.ZodTypeDef,
  unknown
> = z.object({
  alias: types.string(),
  display_name: types.string(),
  id: types.string(),
  kind: types.string(),
}).transform((v) => {
  return remap$(v, {
    "display_name": "displayName",
  });
});
/** @internal */
export type SequencerDevice$Outbound = {
  alias: string;
  display_name: string;
  id: string;
  kind: string;
};

/** @internal */
export const SequencerDevice$outboundSchema: z.ZodType<
  SequencerDevice$Outbound,
  z.ZodTypeDef,
  SequencerDevice
> = z.object({
  alias: z.string(),
  displayName: z.string(),
  id: z.string(),
  kind: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayName: "display_name",
  });
});

export function sequencerDeviceToJSON(
  sequencerDevice: SequencerDevice,
): string {
  return JSON.stringify(SequencerDevice$outboundSchema.parse(sequencerDevice));
}
export function sequencerDeviceFromJSON(
  jsonString: string,
): SafeParseResult<SequencerDevice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SequencerDevice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SequencerDevice' from JSON`,
  );
}
